import { useCallback } from 'react';
import { ProjectFinancialsContractType } from 'api/project';
import { useProjectFinancailContractMappingQuery } from 'queries';

interface ReturnProps {
  isProjectsLoading: boolean;
  checkIsProjectNonBillable: (projectId?: number) => boolean;
}

export const useCheckProjectBillability = (): ReturnProps => {
  const { data: projectsLookup, isLoading: isProjectsLoading } =
    useProjectFinancailContractMappingQuery();

  const checkIsProjectNonBillable = useCallback(
    (projectId?: number) =>
      (!isProjectsLoading &&
        projectId != null &&
        (projectId === 1 || // this is for non-project activity
          projectsLookup?.[projectId]?.financialContractType ===
            ProjectFinancialsContractType.NONBILLABLE)) ??
      false,
    [isProjectsLoading, projectsLookup],
  );

  return { isProjectsLoading, checkIsProjectNonBillable };
};
